import { combineReducers } from 'redux';

import domain from './domain';
import filterByCustomer from './filterByCustomer';

const selected = combineReducers({
  filterByCustomer,
  domain,
});

export default selected;
